import React, {useEffect, useCallback, useState} from 'react';
import Header from '../components/Header';
import {Row, Col, Container} from 'react-bootstrap';
import SideNav from '../components/SideNav/SideNav';
import Results from '../components/Results';
import Filters from '../components/Filters/Filters';
import Compare from '../components/Filters/Compare';
import {useSelector, useDispatch} from 'react-redux';
import {toggleDisplayResults} from '../redux/mobileDisplays';
import {
  selectedQuestion,
  selectedQuestionNumber,
  selectedQuestionSubquestions,
  selectedQuestionResponses,
  selectedQuestionDirection,
  selectedQuestionSubQKeys,
  setSelectedQuestionV,
  setSelectedNote,
} from '../redux/QuestionsSlice';

import {
  changeActiveFilters,
  setFilterCount,
  filterActive,
  compareActive,
  active,
} from '../redux/Filters';

import Loading from '../elements/Loading';
import Pagination from '../elements/Pagination';
import {useSearchParams} from 'react-router-dom';

import useMediaQuery from '../hooks/useMediaQuery';
import '../styles/FrontPage.scss';
import {Base64} from 'js-base64';

function FrontPage({hasData, locale, translations}) {
  const [isLoading, setIsLoading] = useState(true);
  const questionV = useSelector(state => state.questions.selectedQuestionV);

  const isActive = useSelector(state => state.showFilters.isActive);
  const isFilterActive = useSelector(state => state.showFilters.isFilterActive);
  const isCompareActive = useSelector(state => state.showFilters.isCompareActive);
  const loading1 = useSelector(state => state.showFilters.loading1);

  const isTablet = useMediaQuery('(max-width: 992px)');
  const isMobile = useMediaQuery('(max-width: 768px)');
  const displayResults = useSelector(state => state.mobileDisplays.displayResults);
  const displaySideNav = useSelector(state => state.mobileDisplays.displaySideNav);

  const activeFilters = useSelector(state => state.showFilters.activeFilters);
  const year = useSelector(state => state.selectedYear.year);

  const [searchParams] = useSearchParams();

  const dispatch = useDispatch();

  const [params] = useSearchParams();

  const [hasResponse, setHasResponse] = useState(false);

  function evaluateFilterSet(res, funcs) {
    let retVal = false;
    funcs.forEach(f => (retVal |= f(res)));
    return retVal;
  }

  const showSideNav = () => {
    if (isTablet) {
      return displaySideNav;
    } else {
      return !isActive && displaySideNav;
    }
  };

  const viewAnswers = () => {
    dispatch(toggleDisplayResults(true));
    dispatch(filterActive(false));
    dispatch(compareActive(false));
    dispatch(active(false));
  };

  const getData = useCallback(async () => {
    let result = '';
    let data = '';

    console.log(questionV);
    const response = await fetch(
    `/3m_theme_assets/web_apps/apps/mmmSOSI-2022explorer/data/${year}/responses/${questionV}.json`     
    //` https://3m-sosi-data-manager.azurewebsites.net/api/export/response?task=json&build=comp&langVar=${questionV}&suffix=${year}`, {'mode': 'no-cors'}
    // `/3m_theme_assets/web_apps/apps/mmmSOSI-${year}explorer/data/${year}/language/en_US/translations.json` 
    )
     try {   
        result = await response.json();
         data = result.vPay.data.explorerResponse;           
          setHasResponse(true)
        
        } catch (error) {
          console.log('this is the error');       
          console.log(error);
        }

       
    activeFilters?.forEach(filt => {
      let vals = [];
      filt.filteredCategories.forEach(cat => {
        vals.push(res => {
          const val = res[filt?.field];

          if (typeof val === 'string') {
            return val.toLowerCase() === cat?.trans_lang_variable_value.toLowerCase();
          } else {
            return val === cat?.trans_lang_variable_value;
          }
        });
      });

      if (vals.length > 0) {
        data = data.filter(res => evaluateFilterSet(res, vals));
      }
    });

    dispatch(selectedQuestionResponses(data));

  
  }, [questionV, dispatch, activeFilters]);
// }, []);
  


  const setQuestion = useCallback(async () => {
    setIsLoading(true);   
    const question = translations?.Question?.lang.filter(q => {
      return q.v === questionV;
    })[0];
    dispatch(selectedQuestion(question?.vPay.vlang));
    dispatch(selectedQuestionNumber(question?.vPay.vQnum));
    dispatch(selectedQuestionSubquestions(question?.vPay.vLangSub));
    await getData();
    dispatch(selectedQuestionDirection(question?.vPay.vLangQtype));
    dispatch(selectedQuestionSubQKeys(question?.vSubQuestionKeys));
    
    dispatch(setSelectedNote(question?.vPay.vLangNotes));
    setIsLoading(false);
  }, [dispatch, translations?.Question?.lang, questionV, getData]);

  async function onChangeQuestion(ques) {
    dispatch(setSelectedQuestionV(ques));
  }

  function onToggleFilter() {
    getData();
  }

  useEffect(() => {
    setQuestion(questionV);
  }, [questionV, searchParams, setQuestion]);


  useEffect(() => {
    const snapshot = params.get('s');

    if (snapshot != null) {
      const decoded = Base64.decode(snapshot);
      const val = JSON.parse(decoded);

      if (val.activeFilters) {
        dispatch(changeActiveFilters(val.activeFilters));
        dispatch(setFilterCount());
      }

      if (val.question) {
        console.log(val.question);
        dispatch(setSelectedQuestionV(val.question));
      }
    }
  }, [params, dispatch]);


  return (
    <Container className={loading1 ? 'front-page px-0' : 'front-page-loading px-0'}>
      
      <Row>
        <Col>
          <Header {...translations} />
        </Col>
      </Row>
      {hasData ? <>
      <Row className="g-0 p-0 m-0 h-100 position-relative">
        {isFilterActive && isTablet && (
          <button
            onClick={viewAnswers}
            className="position-absolute view-answers d-block d-lg-none"
          >
            VIEW ANSWERS
          </button>
        )}
        {showSideNav() && (
          <Col className={loading1 && 'slide-from-left'} md={5} lg={4} xxl={3}>
            <SideNav
              onChange={onChangeQuestion}
              currentQuestion={questionV}
              locale={locale}
              translations={translations}
            />
          </Col>
        )}
        {/* <Col className = {isMobile && !displayResults && 'd-none'}></Col> */}
        <Col className={isMobile && !displayResults ? 'd-none' : 'pr-0'}>
          {isLoading ? (
            <Loading />
          ) : (
            <div className="resultsWrapper d-flex flex-column">
              <Results translations={translations} />
              {
                <Pagination
                questionNumber={questionV}
                onChange={onChangeQuestion}
                translations={translations}
              /> }
            </div>
          )}
        </Col>
        {isActive && (
          <Col className="slide-from-right pl-0" md={4}>
            {isFilterActive && !isCompareActive && <Filters onToggleFilter={onToggleFilter} />}
            {isCompareActive && !isFilterActive && <Compare />}
          </Col>
        )}
      </Row></>
      : <h1>NO DATA FOR {year}</h1>}
      
    </Container>
  );
}

export default FrontPage;